export default function updateDefaultResponses(state, action) {
  state.defaultMessages = action.payload;
}
